import type { PostingDateCount } from "../types/filter";
import type { FilterOptionPostingDate } from "../types/filtermenu";
import type { TranslationsMap } from "../types/language";

// Creates custom options for postingDate filtermenu
// Includes logic for count and dynamically building the value for Algolia query
export const createPostingDateOptions = (
  postingDateCounts: PostingDateCount[],
  text: TranslationsMap
): FilterOptionPostingDate[] =>
  postingDateCounts.map((data) => ({
    ...data,
    order: 0,
    label: text[data.label],
  }));
